module.exports = __webpack_public_path__ + "static/media/image-small-wave.ba21bd02.svg";